var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.767442 0C1.19128 0 1.53488 0.343599 1.53488 0.767442V2.66047L3.29557 2.30833C4.98448 1.97055 6.73517 2.13128 8.33432 2.77095L8.54275 2.8543C10.1402 3.49328 11.8984 3.61262 13.5676 3.19532C14.3425 3.00161 15.093 3.58767 15.093 4.38638V11.9247C15.093 12.584 14.6443 13.1587 14.0047 13.3186L13.7853 13.3734C11.9745 13.8261 10.0673 13.6967 8.33432 13.0035C6.73517 12.3638 4.98448 12.2031 3.29557 12.5409L1.53488 12.893V21.2326C1.53488 21.6564 1.19128 22 0.767442 22C0.343599 22 0 21.6564 0 21.2326V0.767442C0 0.343599 0.343599 0 0.767442 0Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.a8ed2d222d0856cf30776acb707b0d1c.svg";
export { ForwardRef as ReactComponent };